import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import HandleTable from "./HandleTable";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { GetDialogParam, resumeRequest } from "../TokenProcessing";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
    };
    jsonData?: unknown;
    CLSID?: string;
    Title?: string;
  };
  subData: {
    props: any;
    func: (data: any) => any;
    from: string;
  };
  requestID: string;
}

export const selectDocument = (data: Data) => {
  const { json, subData, requestID } = data;
  let subJson = json.jsonData || {};
  if (json.Params) {
    smetaModals.open(
      <HandleTable
        json={{
          ...json,
          ...subJson,
          CLSID: "{03338F11-FC1E-11D4-A605-0000E8D9CBDB}",
        }}
        subData={{
          props: {
            SectionID: getModalSectionID(),
            Buttons: json.Params.OnlyView === "1" ? 2 : undefined,
            ...json.Params,
            ...subData.props,
            func: subData.func,
            from: subData.from,
          },
        }}
      />,
      {
        Title: "Выбор документа",
        style: getStyleWindow("{03338F11-FC1E-11D4-A605-0000E8D9CBDB}"),
        onClose: () => {
          subData.props?.input?.current?.focus();
          resumeRequest(requestID, subData, {});
        },
        callBacks: true,
      },
    );
  }
};
